import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService as ResourceApiService } from '../../resource/utilities/services/api.service';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { TakeTestComponent } from '@app/modules/assessment/take-test/take-test.component';
import { ResourceFormsComponent } from '@app/modules/resource/resource-forms/resource-forms.component';
import { AppInitializerService } from '@app/app-initializer.service';
import { ScormDetailsComponent } from '@app/modules/scorm/scorm-details/scorm-details.component';
// import { variable } from '@angular/compiler/src/output/output_ast';
import { ApiService } from '@app/modules/scorm/utilites/api.service';
import { ScormOldComponent } from '@app/modules/scorm/scorm-old/scorm-old.component';
import { CourseFormsComponent } from '../course-forms/course-forms.component';


@Component({
	selector: 'app-take-course',
	templateUrl: './take-course.component.html',
	styleUrls: ['./take-course.component.scss']
})


export class TakeCourseComponent implements OnInit, OnDestroy {

	@ViewChild('objectData') objectData: ElementRef;

	showCourseList = true;
	popupRef;
	actualResourceID;
	resourceDetail;
	moduleList = [];
	loader = true;
	contentData: {
		type: 'resource' | 'takeTest',
		data: any
	};
	lastData;
	documentLoaded = false;
	timeProcessed = false;
	height: number = 176;
	canStartPlay = false;
	intervalCleared = false;
	timeLogInterval;
	resourceID;
	YTPlayer;
	YTStatus = false;
	YTIntervalCleared = false;
	YTPlayerReached = false;
	youTubeTimeInterval;
	currentResourceDetail;
	completedPercentage = 0;
	courseRead = 0;
	readStateLoader = true;
	youtubeLoader = false;
	totalYoutubeSegments = 0;
	youtTubeSegmentData = [];
	youtTubeSegmentedData = [];
	oldYouTubeSegmentIndex;
	dataFromLms;
	scormData: any = [];
	patchMessage;
	permissionError = false;
	constructor(
		public gfService: GlobalFunctionService,
		private resourceApiService: ResourceApiService,
		private baseService: BaseService,
		public locale: LocaleService,
		public detectDevice: DetectDeviceService,
		private cdref: ChangeDetectorRef,
		private popup: MatDialog,
		private appInit: AppInitializerService,
		private scormApiservice: ApiService
	) {
	}

	ngOnInit(): void {
		this.loader = true;
		if (this.detectDevice.resolutionState$.value.deviceType === 'mobile') {
			this.showCourseList = false;
		}
		this.getDetail();
	}

	toggleCourseList() {
		this.showCourseList = !this.showCourseList;
		this.cdref.detectChanges();
	}

	getDetail() {
		
		const headers = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.resourceApiService
			.detail(Number(this.actualResourceID), headers)
			.subscribe(
				(response) => {
					
					if (response) {
						this.resourceDetail = response;
						if (this.resourceDetail && this.resourceDetail.hasOwnProperty('infoFields')) {
							if (Array.isArray(this.resourceDetail.infoFields.courseModules)) {
								this.dataBuild();
								this.moduleList = this.resourceDetail.infoFields.courseModules;
							}
						}
						if (this.contentData && this.contentData.type && this.contentData.type === 'resource') {
							this.referenceDetail(this.contentData);
						} else {
							this.loader = false;
						}
					} else {
						this.loader = false;
						this.gfService.openSnackBar('ERROR', {
							message: this.locale.translate('no_data_found'),
							icon: 'clear',
							position: 'before'
						});
					}
				},
				(error) => {
											this.loader = false;
											
												this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
									}
			)
			.add(() => {
				this.getReadStatus();
			})
	}

	getReadStatus() {

        const headers: any = {
            lanCode: sessionStorage.getItem('locale') || 'en'
        };
        
        this.resourceApiService.getResourceReadStatus(this.actualResourceID, headers).subscribe(
            (response) => {
                if (response) {
                    // console.log('readstatus called')
                    if (this.resourceDetail) {
                        this.resourceDetail.read = response.read;
                        this.resourceDetail.lastTimeline = response.lastTimeline;
                        this.resourceDetail.completedPercent = response.completedPercent;
                        this.resourceDetail.moduleReadData = response.course;
                        if (this.moduleList && this.moduleList.length && this.resourceDetail && this.resourceDetail.moduleReadData) {
                            Object.keys(this.resourceDetail.moduleReadData).map(key => {
                                if (key) {
                                    const moduleData = this.moduleList.find(items => items.moduleID === Number(key));
                                    if (moduleData && moduleData.activites && moduleData.activites.length) {
                                        if (this.resourceDetail.moduleReadData[key] && this.resourceDetail.moduleReadData[key].length) {
                                            for (const data of this.resourceDetail.moduleReadData[key]) {
                                                let matchKey;
                                                if (data.resourceID) {
                                                    matchKey = 'resourceID';
                                                } else if (data.assessmentID) {
                                                    matchKey = 'assessmentID';
                                                }
                                                const activity = moduleData.activites.find(items => items.id === data[matchKey]);
                                                if (activity) {

                                                    activity.read = data.read;
                                                    activity.completedPercent = data.completedPercent;
                                                }
                                            }
                                        }
                                    }
                                }
                            });
                            this.moduleList.map((item, i) => {
                            
                                if (item.activites?.length > 0)
                                    item.moduleCompleted = item.activites.every((activity) => activity.read)
                                else item.moduleCompleted = false
                            })
                        }
                        this.updatePercentage(true);
                    }
                }
            },
            (error) => {
                this.gfService.errorHandler(error, {
                    snackBar: {
                        position: 'before'
                    }
                });
            }
        )
            .add(() => {
                this.readStateLoader = false;
                this.cdref.detectChanges();
            });
            console.log(this.moduleList, "this.modulelist")

    }

	dataBuild() {

		for (const data of this.resourceDetail.infoFields.courseModules) {
			data.opened = false;
			
			if (data.activites && data.activites.length) {
				// delete data.activites[1].resourceFormat;
				// delete data.activites[2].resourceFormat;
				// data.activites[1].id = 579;
				// data.activites[2].id = 571;
                
				for (const activity of data.activites) {
					activity.selected = false;
					activity.contentType = this.baseService.referenceType('courseContentType', activity.type);
					if (activity.resourceFormat) {
						activity.resourceFormat = this.baseService.referenceType('resourceFormat', activity.resourceFormat);
					}
					if (activity.resourceTypeID) {
						activity.resourceTypeID = this.baseService.referenceType('resourceType', activity.resourceTypeID);
					}
				}
				if (!this.lastData) {
					data.activites[0].selected = true;
					data.opened = true;
					if (data.activites[0].type === 'AT') {
						this.contentData = {
							type: 'takeTest',
							data: data.activites[0].id
						};
					} else {
						this.contentData = {
							type: 'resource',
							data: data.activites[0]
						};
					}
					this.lastData = data.activites[0];
				}
			} else {
				data.activites = [];
			}
			if (data.references && data.references.length) {
				const references = [];
				for (const record of data.references) {
					const cardData: ContentImageCard = {
						title: record.title,
						date: this.gfService.dateFormat(record.createdAt, 'MMM d, y'),
						thumbnail: ''
					};
					if (record.description) {
						cardData.description = record.description;
					}
					if (record.resource.thumbnail) {
						cardData.thumbnail = record.resource.thumbnail;
					}
					if (record.resourceFormat) {
						record.resourceFormat = this.baseService.referenceType('resourceFormat', record.resourceFormat);
						cardData.format = record.resourceFormat.key;
						if (cardData.thumbnail === '') {
							cardData.thumbnail = record.resourceFormat.image;
						}
					}
					record.resourceTypeID = this.baseService.referenceType('resourceType', record.resourceTypeID);
					if (record.resourceTypeID) {
						cardData.type = record.resourceTypeID.caption;
					}
					const extraData = {
						resourceID: record.resourceID,
						createdBy: record.createdBy
					};
					references.push(this.gfService.JSONMerge(cardData, extraData));
				}
				data.references = references;
			} else {
				data.references = [];
			}
		}
	}

	resetYouTubeProcess() {
		if (this.youTubeTimeInterval) {
			clearInterval(this.youTubeTimeInterval);
		}
		localStorage.removeItem('segmentData');
		this.youtTubeSegmentedData = [];
		this.youtTubeSegmentData = [];
		this.totalYoutubeSegments = 0;
		this.oldYouTubeSegmentIndex = null;
		this.YTStatus = false;
		this.YTIntervalCleared = false;
		this.YTPlayerReached = false;
	}

	resetTimeLog() {
		if (this.timeLogInterval) {
			this.timeLogInterval.clearInterval();
		}
		this.intervalCleared = true;
		localStorage.removeItem('timeLogData');
	}

	referenceDetail(content, type = '') {
		this.patchMessage = null;
		this.permissionError = false;
		if (navigator.onLine) {
			this.currentResourceDetail = null;
			this.canStartPlay = false;
			this.intervalCleared = false;
			this.documentLoaded = false;
			this.timeProcessed = false;
			this.height = 176;

			this.resetYouTubeProcess();
			this.resetTimeLog();


			this.loader = true;
			const headers = {
				lanCode: sessionStorage.getItem('locale') || 'en'
			};
			this.resourceID = content.data.id;
			
			this.resourceApiService.detail(this.resourceID, headers).subscribe(

				(response) => {
					
					if (response) {

						content.data = response;
						content.data.status = this.baseService.referenceType('resourceStatus', content.data.status);
						content.data.resourceFormat = this.baseService.referenceType('resourceFormat', content.data.resourceFormat);
						content.data.resourceTypeID = this.baseService.referenceType(
							'resourceType',
							content.data.resourceTypeID
						);
						if (content.data.registrationStatus) {
							content.data.registrationStatus = this.baseService.referenceType('registrationStatus', content.data.registrationStatus);
						}
						if (![null, undefined].includes(content.data.registrationRequestStatus)) {
							content.data.registrationRequestStatus = this.baseService.referenceType('registrationRequestStatus', content.data.registrationRequestStatus);
						}
						content.data.resourceAction = this.baseService.getResourceAction(content.data, null);
						
						// content.data.registerLearning = {
						// 	registerLearning: true,
						// 	requestForApproval: true,
						// 	requestForRegistration: true,
						// 	register: true
						// };

						if (content.data.resourceFormat) {
							if (content.data.resourceFormat && content.data.resourceFormat.key === 'document') {
								if (content.data.resource && content.data.resource.file) {
									const fileExt = content.data.resource.file.split('.').pop().toLowerCase();
									if (fileExt === 'pdf') {
										content.data.resource.file = content.data.resource.file + '#toolbar=0';
									} else {
										content.data.resource.file = `https://view.officeapps.live.com/op/embed.aspx?src=${content.data.resource.file}`;
									}
								}
								// content.data.resource.file = content.data.resource.file + '#toolbar=0';
							} else if (content.data.resourceFormat.key === 'link') {
								if (content.data.resource && content.data.resource.link) {
									content.data.resource.urlData = this.gfService.embed(content.data.resource.link);
								}
								if (content.data.resource.thumbnail === '') {
									content.data.resource.thumbnail = content.data.resourceFormat.image;
								}
							}
						}

						this.currentResourceDetail = content.data;

						if (type === 'SCORM_POPUP') {
							const width = 800;
							const height = 600;
							const left = (window.innerWidth - 500) / 2;
							const top = (window.innerHeight - 400) / 2;
							const jsonData = {
								scormVersion: this.currentResourceDetail.resource.scormVersion,
								scormUrl: this.currentResourceDetail.resource.scormURL,
								lmsData: this.dataFromLms,
								apiUrl: this.appInit.configuration.API_URL,
								scormPlayerURL: this.appInit.configuration.SCORM_PLAYER_URL
							};

							// Serialize the JSON data to a string (JSON string)
							let jsonDataString = JSON.stringify(jsonData);
							jsonDataString = encodeURIComponent(jsonDataString)

							// Construct the URL for the popup component
							const popupURL = `${this.appInit.configuration.SCORM_PLAYER_URL}?scormData=${jsonDataString}`; // Update this URL if necessary
							
							// Open the popup window
							const popupWindow=window.open(popupURL, 'PopupWindow', `width=${width},height=${height},left=${left},top=${top}`);
							const intervalId = setInterval(() => {
								if (popupWindow && popupWindow.closed) {
									if (this.currentResourceDetail.resource.scormVersion === 1) {
										
											// console.log(this.currentResourceDetail, this.scormData)




											const headers: any = {
												lanCode: sessionStorage.getItem('locale') || 'en'
											};
											this.scormApiservice.getScormLms(headers, this.currentResourceDetail.resourceID).subscribe((response: any) => {
												this.dataFromLms = { cmi: response.cmi };
												this.scormData = response;
												if (![undefined, null].includes(this.scormData)) {


													if (this.scormData.resourceID && this.currentResourceDetail.resourceID) {
														// console.log(this.scormData, 'afu')


														if (['passed', 'completed'].includes(this.scormData?.cmi?.core?.lesson_status) && this.currentResourceDetail?.completedPercent !== 100) {
															this.addReadLog('segment', { cancelable: 'N' }, 0, 'scorm');

														}
														else {

															//to comment
															// console.log('else afu')
															// this.currentResourceDetail.resource.scormTotalPageCount = 5;
															if (![null, undefined, ''].includes(this.currentResourceDetail?.resource?.scormTotalPageCount)) {

																// console.log(this.scormData?.cmi?.core?.lesson_location)

																let completed = JSON.parse(this.scormData?.cmi?.core?.lesson_location)
																completed = completed?.completed?.length || 0


																if (![null, undefined, ''].includes(completed) && completed > 0) {
																	let progressValue: any = (completed / this.currentResourceDetail?.resource?.scormTotalPageCount) * 100
																	progressValue = parseInt(progressValue)

																	// console.log('before calling add log', progressValue, 'prog val', this.scormData?.cmi?.core?.location)
																	this.addReadLog('segment', { cancelable: 'N' }, progressValue, 'scorm');

																}

															}
														}

													}
												}
											},
												(error) => {
													
													this.gfService.errorHandler(error, {
														snackBar: {
															position: 'before'
														}
													});
												}
											)




											content.data.selected = false;
											if (this.lastData) {
												this.lastData.selected = false;
											}

											//close here
										
									}else if (this.currentResourceDetail.resource.scormVersion === 2) {
								
										
											const headers: any = {
												lanCode: sessionStorage.getItem('locale') || 'en'
											};
											this.scormApiservice.getScormLms(headers, this.currentResourceDetail.resourceID).subscribe((response: any) => {
												this.dataFromLms = { cmi: response.cmi };
												this.scormData = response;
												if (![undefined, null].includes(this.scormData)) {
												

													if (this.scormData.resourceID && this.currentResourceDetail.resourceID) {
														// console.log(this.scormData, 'afu')


														if (this.scormData?.cmi?.completion_status === 'completed' && this.currentResourceDetail?.completedPercent !== 100) {

															this.addReadLog('segment', { cancelable: 'N' }, 0, 'scorm');





														}
														else {

															//to comment
															// console.log('else afu')
															// this.currentResourceDetail.resource.scormTotalPageCount = 5;
															if (![null, undefined, ''].includes(this.currentResourceDetail?.resource?.scormTotalPageCount)) {

																// console.log(this.scormData?.cmi?.location)

																let completed = JSON.parse(this.scormData?.cmi?.location)
																completed = completed?.completed?.length || 0


																if (![null, undefined, ''].includes(completed) && completed > 0) {
																	let progressValue: any = (completed / this.currentResourceDetail?.resource?.scormTotalPageCount) * 100
																	progressValue = parseInt(progressValue)

																	// console.log('before calling add log', progressValue, 'prog val', this.scormData?.cmi?.location)
																	this.addReadLog('segment', { cancelable: 'N' }, progressValue, 'scorm');

																}

															}
														}

													}
												}
											},
												(error) => {
													this.gfService.errorHandler(error, {
														snackBar: {
															position: 'before'
														}
													});
												}
											)




											content.data.selected = false;
											if (this.lastData) {
												this.lastData.selected = false;
											}

											//close here
										
									}
									clearInterval(intervalId);
								} else if (!popupWindow) {
									// The popup window was blocked or not opened
									console.log('Popup window was blocked or not opened.');
									
									// Stop the interval when the popup is blocked or not opened
									clearInterval(intervalId);
								}
							}, 1000);
						
						}
						// console.log(this.currentResourceDetail);
						this.cdref.detectChanges();
					} else {
						this.loader = false;
						setTimeout(() => {
							this.checkSupport();
						});
					}
				},
				(error) => {
					
					if (error.error.hasOwnProperty('errorCode')) {
						
						if (error.error.errorCode === 'PERMISSION_DENIED') {
							this.patchMessage = 'you_dont_have_permission_to_access_this_resource';
						} else if (error.error.errorCode === 'NOT_PUBLISHED') {
							this.patchMessage = 'oops_this_resource_has_been_unpublished';
						} else if (error.error.errorCode === 'RECORD_NOT_FOUND') {
							this.patchMessage = 'oops_this_resource_has_been_deleted';
						}
						this.permissionError = true;
						// this.featureLoader = false;
						this.loader = false;
						if (this.popupRef && this.popupRef.componentInstance) {
							this.popupRef.componentInstance.popupLoader = false;
						}
					}
					
					if (!this.permissionError) {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					}
				}
			)
				.add(() => {
					if (!this.permissionError) {
					this.getReferenceReadStatus();
					}

				});
		}
	}

	getReferenceReadStatus() {
		const headers: any = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.resourceApiService.getResourceReadStatus(this.resourceID, headers).subscribe(
			(response) => {
				if (response) {

					if (this.currentResourceDetail) {
						this.currentResourceDetail.read = response.read;
						this.currentResourceDetail.lastTimeline = response.lastTimeline;
						this.currentResourceDetail.completedPercent = response.completedPercent;

						this.currentResourceDetail.playlistReadData = response.playlist;
						if (this.currentResourceDetail.resourceTypeID && !['knowledgecard', 'playlist', 'course'].includes(this.currentResourceDetail.resourceTypeID.key)) {
							if (['answer'].includes(this.currentResourceDetail.resourceTypeID.key)) {
								if (!this.currentResourceDetail.read) {
									if (this.currentResourceDetail.resource.duration) {
										this.processTimeLog();
									} else {
										this.addReadLog('time', 'general');
									}
								}
							}
							if (this.currentResourceDetail.resourceFormat) {
								if (['audio', 'video', 'page', 'document'].includes(this.currentResourceDetail.resourceFormat.key) && this.currentResourceDetail.resource) {
									if (['audio', 'video'].includes(this.currentResourceDetail.resourceFormat.key) && this.currentResourceDetail.resource.file) {
										if (!this.currentResourceDetail.read) {
											this.canStartPlay = true;
											// this.getReadSegmentLog();
										} else {
											this.canStartPlay = true;
										}
									} else if (['document'].includes(this.currentResourceDetail.resourceFormat.key) && !this.currentResourceDetail.read) {
										if (this.currentResourceDetail.resource.duration) {
											this.processTimeLog();
										}
										// this.getReadTimeLog();
									}
								} else if (this.currentResourceDetail.resourceFormat.key === 'link') {
									if (!this.currentResourceDetail.read && this.currentResourceDetail.resource && (!this.currentResourceDetail.resource.urlData || (this.currentResourceDetail.resource.urlData && this.currentResourceDetail.resource.urlData.type === 'youtube'))) {
										this.readExternalLinkLog();
									}
								} else if (this.currentResourceDetail.resourceFormat.key === 'scorm') {

									if (!this.currentResourceDetail.read && this.currentResourceDetail.resource) {
										this.scormReadLog();
									}
								}
							}
						}
						if (!this.currentResourceDetail.read && this.currentResourceDetail.resource && this.currentResourceDetail.resource.image && this.currentResourceDetail.resource.image.length) {
							if ((this.detectDevice.resolutionState$.value.xl && this.currentResourceDetail.resource.image.length <= 8) || (this.detectDevice.resolutionState$.value.lg && this.currentResourceDetail.resource.image.length <= 6) || ((this.detectDevice.resolutionState$.value.md || this.detectDevice.resolutionState$.value.sm) &&
								this.currentResourceDetail.resource.image.length <= 4) || (this.detectDevice.resolutionState$.value.xs && this.currentResourceDetail.resource.image.length <= 2)) {
								this.readMoreForImage({});
							}
						}
					}
				}
			},
			(error) => {
				this.loader = false;
				
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.loader = false;
				this.cdref.detectChanges();
				setTimeout(() => {
					this.checkSupport();
				});
				this.loadYouTube();
			});
	}

	processTimeLog() {
		if (!this.currentResourceDetail.read) {
			this.intervalCleared = false;
			this.timeLogInterval = this.gfService.intervalTimer(() => {
				let storageData: any = [];
				if (localStorage.getItem('timeLogData')) {
					storageData = JSON.parse(localStorage.getItem('timeLogData'));
				}
				const findData = storageData.find(items => items.resourceID === this.resourceID);
				if (findData) {
					if (findData.totalDurationInSeconds <= findData.newTime) {
						if (this.timeLogInterval) {
							this.addReadLog('time', { cancelable: 'N' });
							this.timeLogInterval.clearInterval();
							this.intervalCleared = true;
						}
					} else {
						findData.currentTime = Number(findData.currentTime);
						findData.currentTime += (this.appInit.configuration.pageReadLogTime / 1000);
						findData.newTime = findData.currentTime;
					}
				} else {
					const pushJson: any = {
						resourceID: this.resourceID,
						totalDurationInSeconds: this.hmsToSecondsOnly(this.currentResourceDetail.resource.duration),
						totalDuration: this.currentResourceDetail.resource.duration,
						currentTime: (this.appInit.configuration.pageReadLogTime / 1000),
						newTime: (this.appInit.configuration.pageReadLogTime / 1000)
					};
					if (pushJson.totalDurationInSeconds <= pushJson.newTime) {
						this.addReadLog('time', { cancelable: 'N' });
						this.resetTimeLog();
					} else {
						storageData.push(pushJson);
					}
				}
				const currentTimeData = storageData.find(items => items.resourceID === this.resourceID);
				if (currentTimeData && !this.courseRead) {
					this.updatePercentage(false);
					currentTimeData.courseParentPercentage = this.completedPercentage;
					currentTimeData.courseParentID = this.actualResourceID;
				}
				if (storageData.length) {
					localStorage.setItem('timeLogData', JSON.stringify(storageData));
				}
			}, this.appInit.configuration.pageReadLogTime);
			document.addEventListener('visibilitychange', (e) => {
				if (!this.intervalCleared) {
					if (document.hidden) {
						this.timeLogInterval.pause();
					} else {
						this.timeLogInterval.resume();
					}
				}
			});
		}
	}

	scormReadLog() {
		if (this.currentResourceDetail && !this.currentResourceDetail.read) {

			if (![undefined, null].includes(this.scormData)) {
				if (this.scormData.resourceID && this.currentResourceDetail.resourceID) {

					if (this.scormData.cmi.completion_status && this.scormData.cmi.completion_status === 'completed') {
						this.addReadLog('segment', { cancelable: 'N' });
					} else {
						// console.log(this.currentResourceDetail, "this.currentResourceDetail>>>>>>>>>>")

					}
				}
			}

		}
	}

	readExternalLinkLog() {
		setTimeout(() => {
			// this.gfService.blockHttpCall = false;
			if (this.currentResourceDetail.resource.urlData.type !== 'youtube') {
				this.addReadLog('time', { cancelable: 'N' });
			}
		}, this.appInit.configuration.externalLinkLogTime);
	}

	processReadForImage() {
		if (navigator.onLine) {
			if (this.currentResourceDetail && !this.currentResourceDetail.read && this.currentResourceDetail.resourceFormat && this.currentResourceDetail.resourceFormat.key && this.currentResourceDetail.resourceFormat.key === 'image') {
				// this.gfService.blockHttpCall = false;
				this.addReadLog('time', { cancelable: 'N' });
			}
		}
	}

	loadYouTube() {
		if (navigator.onLine) {
			if (this.currentResourceDetail && this.currentResourceDetail.resource && this.currentResourceDetail.resource.urlData && this.currentResourceDetail.resource.urlData.isFormatted && this.currentResourceDetail.resource.urlData.type === 'youtube') {
				this.youtubeLoader = true;
				let videoId = this.currentResourceDetail.resource.link.split('v=')[1];
				const ampersandPosition = videoId.indexOf('&');
				if (ampersandPosition != -1) {
					videoId = videoId.substring(0, ampersandPosition);
				}
				this.YTPlayer = new (<any>window).YT.Player('YTPlayer', {
					height: '100%',
					width: '100%',
					videoId,
					playerVars: { 'autoplay': 0, 'rel': 0, 'controls': 2 },
					events: {
						'onReady': () => {
							this.youtubeLoader = false;
							this.setYouTubeSegmentData();
							if (navigator.onLine && this.currentResourceDetail.lastTimeline) {
								const duration = this.gfService.getTimeToSeconds(this.currentResourceDetail.lastTimeline, { timeFormat: 'hh:mm:ss', duration: 'seconds' });
								this.YTPlayer.seekTo(duration, true);
								this.YTPlayer.playVideo();
							}
						},
						'onStateChange': (event) => {
							this.processYouTube(event);
						}
					}
				});
			}
		}
	}

	setYouTubeSegmentData() {
		// if (!this.currentResourceDetail.read && navigator.onLine && this.currentResourceDetail.resourceAction && this.currentResourceDetail.resourceAction.readLog) {
		if (!this.currentResourceDetail.read && navigator.onLine) {
			this.totalYoutubeSegments = Math.round(this.YTPlayer.getDuration() / this.appInit.configuration.videoReadSeconds);
			if (this.totalYoutubeSegments) {
				for (let i = 1; i <= this.totalYoutubeSegments; i++) {
					let start = (i - 1) * this.appInit.configuration.videoReadSeconds;
					let end = i * this.appInit.configuration.videoReadSeconds;
					if (i === this.totalYoutubeSegments) {
						end = this.YTPlayer.getDuration();
					}
					this.youtTubeSegmentData.push(
						{
							start,
							end
						}
					);
				}
			}
		}
	}

	processYouTube(event) {
		// if (!this.YTPlayerReached && navigator.onLine && this.currentResourceDetail.resourceAction && this.currentResourceDetail.resourceAction.readLog) {
		if (!this.YTPlayerReached && navigator.onLine) {
			if (!this.YTStatus) {
				this.YTStatus = true;
				this.youTubeTimeInterval = setInterval(() => {
					// if (this.YTPlayer.getCurrentTime() >= this.appInit.configuration.videoReadSeconds || this.YTPlayer.getDuration() <= this.appInit.configuration.videoReadSeconds) {
					// 	this.YTStatus = false;
					// 	this.YTIntervalCleared = false;
					// 	this.YTPlayerReached = true;
					// 	clearInterval(this.youTubeTimeInterval);
					// 	// this.gfService.blockHttpCall = false;
					// 	this.addReadLog('time', { cancelable: 'N' });
					// }

					if (this.currentResourceDetail.read) {
						this.updatedTime(this.YTPlayer.getCurrentTime());
					} else {
						const index = this.youtTubeSegmentData.findIndex(items => items.start <= this.YTPlayer.getCurrentTime() && items.end >= this.YTPlayer.getCurrentTime());
						if (((this.YTPlayer.getCurrentTime() >= this.appInit.configuration.videoReadSeconds || index === 0) &&
							index !== -1 && ([null, undefined].includes(this.oldYouTubeSegmentIndex) || this.oldYouTubeSegmentIndex !== index))
							|| this.YTPlayer.getDuration() <= this.appInit.configuration.videoReadSeconds) {
							this.youtTubeSegmentedData.push(index + 1);
							this.youtTubeSegmentedData.sort();
							this.YTStatus = false;
							this.YTIntervalCleared = false;
							this.YTPlayerReached = true;
							if ((index + 1) === this.totalYoutubeSegments) {
								// To add read log if 80% of video segment is passed
								this.addReadLog('segment', { cancelable: 'N' });
								// this.updateRead(null);
								this.YTIntervalCleared = true;
								clearInterval(this.youTubeTimeInterval);
								localStorage.removeItem('segmentData');
							} else {
								const segmentData = {
									totalSegment: this.totalYoutubeSegments,
									segments: this.youtTubeSegmentedData,
									currentSegment: index + 1,
									currentTime: this.gfService.formatTime(Math.round(this.YTPlayer.getCurrentTime()), 'hh:mm:ss')
								};
								this.segments(segmentData);
							}
							// } else
							if (event.data === 2) {
								// To clear Internal at end of the video
								this.YTIntervalCleared = true;
								clearInterval(this.youTubeTimeInterval);
							}

							this.oldYouTubeSegmentIndex = index;
						}
					}

				}, 1000);
			}
			if (event.data === 2) {
				this.YTIntervalCleared = true;
				clearInterval(this.youTubeTimeInterval);
			} else if (event.data === 1 && this.YTStatus && this.YTIntervalCleared) {
				this.YTStatus = false;
				this.YTIntervalCleared = false;
				this.processYouTube(event);
			}
		}
	}

	embedLink(url) {
		if (navigator.onLine) {
			this.readExternalLinkLog();
			this.gfService.windowNavigate(url, '_blank');
		}
	}

	readMore(event) {
		if (!this.timeProcessed) {
			if (event.enabled) {
				if (event.read) {
					this.processTimeLog();
					this.timeProcessed = true;
				}
			} else {
				this.processTimeLog();
				this.timeProcessed = true;
			}
		}
	}

	readMoreForImage(event) {
		if (!this.timeProcessed) {
			if (event.enabled) {
				if (event.read) {
					this.processReadForImage();
					this.timeProcessed = true;
				}
			} else {
				this.processReadForImage();
				this.timeProcessed = true;
			}
		}
	}

	segments(data) {
		if (!this.currentResourceDetail.read) {
			let storageData: any = this.baseService.processSegmentLog(data, this.resourceID);
			const currentSegmentData = storageData.find(items => items.resourceID === this.resourceID);
			if (currentSegmentData && !this.courseRead) {
				this.updatePercentage(false);
				currentSegmentData.courseParentPercentage = this.completedPercentage;
				currentSegmentData.courseParentID = this.actualResourceID;
			}
			localStorage.setItem('segmentData', JSON.stringify(storageData));
			console.log(storageData);

			if (this.currentResourceDetail.resourceFormat && this.currentResourceDetail.resourceFormat.key) {
				if (['video', 'audio'].includes(this.currentResourceDetail.resourceFormat.key) && storageData.length) {
					if (storageData[0].currentSegment === storageData[0].totalSegment) {
						// this.updateRead(null);
						this.addReadLog('segment', { cancelable: 'N' });
						// localStorage.removeItem('segmentData');
					}
				}
			}
		}
	}

	updatedTime(time) {
		if (this.currentResourceDetail && this.currentResourceDetail.read) {
			let storageData: any = this.baseService.processSegmentDuration(time, this.resourceID);
			localStorage.setItem('segmentData', JSON.stringify(storageData));
		}
	}

	addReadLog(type: 'time' | 'segment', additionalHeaderInfo: any = {}, progress: number = 0, data = '') {
		let apiData = {};
		if (type === 'segment') {

			if (progress > 0) {
				apiData = {
					type: 0,
					completedPercent: progress
				}
			}
			else {
				apiData = {
					type: 0
				};
			}
		} else if (type === 'time') {
			apiData = {
				type: 1
			};

		}
		const headers: any = {};
		if (additionalHeaderInfo.cancelable) {
			headers.cancelable = additionalHeaderInfo.cancelable;
		}
		
		this.resourceApiService.addReadLog(apiData, this.resourceID, headers).subscribe(
			(response) => {
				// console.log('addlog called', this.currentResourceDetail.completedPercent, this.scormData)

				if (progress > 0) {
					this.currentResourceDetail.completedPercent = progress;
					// this.updatePercentage(true);
				}
				else {
					this.currentResourceDetail.completedPercent = 100;
					this.currentResourceDetail.read = 1;

				}
				this.updatePercentage();


				if (type === 'segment') {
					localStorage.removeItem('segmentData');
					if (data === 'scorm') {
						this.getReadStatus();
					}
				} else if (type === 'time') {
					localStorage.removeItem('timeLogData');
					if (this.timeLogInterval) {
						this.timeLogInterval.clearInterval();
						this.intervalCleared = true;
					}
				}
				if (type === 'time') {
					let editorialTypes = this.baseService.resourceType;
					let editorialKeys = [];
					editorialTypes.forEach((items) => {
						if (items.editorial) {
							editorialKeys.push(items.key);
						}
					});
					if (this.currentResourceDetail && this.currentResourceDetail.resourceTypeID && (editorialKeys.includes(this.currentResourceDetail.resourceTypeID.key) || ['knowledgeBead'].includes(this.currentResourceDetail.resourceTypeID.key))) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.currentResourceDetail });

					}
				}
			},
			(error) => { }
		).add(() => {
			// this.gfService.blockHttpCall = true;
		});
	}

	checkSupport() {
		if (this.objectData && this.objectData.nativeElement) {
			const el: HTMLElement = this.objectData.nativeElement;
			el.addEventListener('load', this.isDocumentLoaded.bind(this));
		}
	}

	hmsToSecondsOnly(str) {
		var p = str.split(':'),
			s = 0, m = 60;

		while (p.length > 0) {
			s += m * parseInt(p.pop(), 10);
			m *= 60;
		}

		return s;
	}

	setCourse (data, sequence) {
		if (sequence) {
			if (navigator.onLine) {
				let title = this.locale.translate('course');
				let content = this.locale.translate('enforce_sequencing_of_activities_content');
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					autoFocus: false,
					data: {
						action: 'alert',
						classes: 'warning',
						popup: true,
						icon: 'warning',
						title,
						content,
						buttons: [
									{
										type: 'main-action',
										caption: this.locale.translate('ok'),
										key: 'yes'
									},
								],
					},
					disableClose: true,
					maxWidth: '560px'
				});
				dialogRef.afterClosed().subscribe((resp) => {
					if (resp) {
						
					}
				});
			}
		} else {
			if (navigator.onLine) {
				if (!data.selected) {
					this.contentData = null;
					this.cdref.detectChanges();
					if (this.lastData) {
						this.lastData.selected = false;
					}
					data.selected = true;
					// this.lastData = data;
					if (![null, undefined].includes(data?.resourceTypeID?.value) && data?.resourceTypeID?.value === 15) {
						this.loader = true;
						data.selected = true;
						const headers: any = {
							lanCode: sessionStorage.getItem('locale') || 'en'
						};
						this.scormApiservice.getScormLms(headers, data.id).subscribe((response: any) => {
	
							if (response) {
								this.dataFromLms = { cmi: response.cmi };
								this.scormData = response;
							}
						},
							(error) => {
								this.gfService.errorHandler(error, {
									snackBar: {
										position: 'before'
									}
								});
							}
						)
	
						this.loader = false;
						this.updateRead(data, 'SCORM_POPUP');
					}
					else {
						this.updateRead(data);
					}
				}
			}
		}
	}

	reloadCurrentResource(event) {
		this.referenceDetail({ data: { id: this.currentResourceDetail.resourceID } });
	}

	updateRead(data, type = '') {

		let status = false;
		if (this.currentResourceDetail) {
			if (!localStorage.getItem('segmentData') && !localStorage.getItem('timeLogData')) {
				status = true;
			}
			let storageData: any = [];
			if (localStorage.getItem('segmentData')) {
				storageData = JSON.parse(localStorage.getItem('segmentData'));
				const resourceSegment = storageData.find(items => items.resourceID === this.resourceID);
				if (resourceSegment && ((resourceSegment.newSegments && resourceSegment.newSegments.length) || (!resourceSegment.newSegments && resourceSegment.hasOwnProperty('currentTime')))) {
					// this.loader = true;
					this.addReadSegmentLog(resourceSegment, data);
				} else {
					status = true;
					localStorage.removeItem('segmentData');
				}
			}
			if (localStorage.getItem('timeLogData') && !this.currentResourceDetail.read) {
				storageData = JSON.parse(localStorage.getItem('timeLogData'));
				const resourceTime = storageData.find(items => items.resourceID === this.resourceID);
				if (resourceTime && resourceTime.newTime) {
					this.loader = true;
					this.addReadTimeLog(resourceTime, data);
				} else {
					status = true;
					localStorage.removeItem('timeLogData');
					if (this.timeLogInterval) {
						this.timeLogInterval.clearInterval();
						this.intervalCleared = true;
					}
				}
			}
		} else {
			status = true;
		}
		if (data && status) {
			this.navigation(data, type);
		}
	}

	addReadSegmentLog(segmentData, data) {
		let apiData: any = {};
		if (segmentData.newSegments) {
			const segments = segmentData.newSegments.map(data => { return Number(data) });
			apiData = {
				segments,
				totalSegments: segmentData.totalSegment,
				lastTimeline: segmentData.currentTime
			};
		} else if (segmentData.hasOwnProperty('currentTime')) {
			apiData = {
				lastTimeline: segmentData.currentTime
			};
		}
		const headers: any = {
			cancelable: 'N'
		};
		// this.gfService.blockHttpCall = false;
		
		this.resourceApiService.addReadSegmentLog(apiData, this.resourceID, headers).subscribe(

			(response) => {

				if (response && response.read) {
					this.currentResourceDetail.read = true;
					this.updatePercentage();
					let editorialTypes = this.baseService.resourceType;
					let editorialKeys = [];
					editorialTypes.forEach((items) => {
						if (items.editorial) {
							editorialKeys.push(items.key);
						}
					});
					if (this.currentResourceDetail && this.currentResourceDetail.resourceTypeID && (editorialKeys.includes(this.currentResourceDetail.resourceTypeID.key) || ['knowledgeBead'].includes(this.currentResourceDetail.resourceTypeID.key))) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.currentResourceDetail });
					}
				}
				localStorage.removeItem('segmentData');
			},
			(error) => { }
		).add(() => {
			if (data) {
				this.navigation(data);
			}
			// this.gfService.blockHttpCall = true;
		});
	}

	addReadTimeLog(timeData, data) {
		let timeSpent = timeData.newTime;
		if (timeData.newTime > timeData.totalDurationInSeconds) {
			timeSpent = timeData.totalDurationInSeconds;
		}
		const apiData = {
			timeSpent,
			totalTime: this.currentResourceDetail.resource.duration
		};
		const headers: any = {
			cancelable: 'N'
		};
		// this.gfService.blockHttpCall = false;
		
		this.resourceApiService.addReadTimeLog(apiData, this.resourceID, headers).subscribe(
			(response) => {

				localStorage.removeItem('timeLogData');
				if (this.timeLogInterval) {
					this.timeLogInterval.clearInterval();
					this.intervalCleared = true;
				}
				if (response && response.read) {
					this.currentResourceDetail.read = true;
					this.updatePercentage();
					let editorialTypes = this.baseService.resourceType;
					let editorialKeys = [];
					editorialTypes.forEach((items) => {
						if (items.editorial) {
							editorialKeys.push(items.key);
						}
					});
					if (this.currentResourceDetail && this.currentResourceDetail.resourceTypeID && (editorialKeys.includes(this.currentResourceDetail.resourceTypeID.key) || ['knowledgeBead'].includes(this.currentResourceDetail.resourceTypeID.key)) && response && response.read) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.currentResourceDetail });
					}
				}
			},
			(error) => { }
		).add(() => {
			if (data) {
				this.navigation(data);
			}
			// this.gfService.blockHttpCall = true;
		});
	}

	navigation(data, type = '') {
		if (data.type === 'AT') {
			this.currentResourceDetail = null;
			this.contentData = {
				type: 'takeTest',
				data: data.id
			};
			this.loader = false;
		} else {
			this.contentData = {
				type: 'resource',
				data
			};
			if (this.timeLogInterval) {
				this.timeLogInterval.clearInterval();
				this.intervalCleared = true;
			}

			this.referenceDetail(this.contentData, type);
		}
		this.lastData = data;
	}

	dialogClose() {
		if (navigator.onLine) {
			// this.gfService.blockHttpCall = false;
			if (this.popupRef) {
				this.popupRef.close(this.popupRef.componentInstance.dialogCloseData || 'close');
			}
			if (this.currentResourceDetail) {
				this.updateRead(null);
			}
		}
	}

	updatePercentage(apiCall = true) {

        if (this.moduleList.length && !this.courseRead) {

            let total = 0;
            for (const module of this.moduleList) {
                if (this.currentResourceDetail) {
                    const activity = module.activites.find(items => items.id === this.currentResourceDetail.resourceID);
                    if (activity && this.currentResourceDetail.read) {
                        activity.read = true;
                    }
                }
                total = total + module.activites.length;
            }

            let completed = 0;
            for (const module of this.moduleList) {
                for (const activity of module.activites) {
                    if (activity.read) {
                        completed = completed + 1;
                    }
                }
            }
            const completedPercentage = (completed / total) * 100;
            if (completedPercentage !== this.completedPercentage && completedPercentage >= 100) {
                if (apiCall) {
                    const headers: any = {};
                    let apiData: any = {};
                    
                    this.resourceApiService.courseCompleted(apiData, Number(this.actualResourceID), headers).subscribe(
                        (response) => {

                            // console.log('Success')
                        },
                        (error) => { });
                }
            }
            if (completedPercentage !== this.completedPercentage) {

                this.completedPercentage = completedPercentage;
                if (apiCall) {

                    const apiData = {
                        type: 1,
                        completedPercent: this.completedPercentage
                    };

                    const headers: any = {};
                    
                    this.resourceApiService.addReadLog(apiData, this.actualResourceID, headers).subscribe(
                        (response) => {

                            if (response && response.read) {
                                this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.resourceDetail });
                            }
                        },
                        (error) => { }
                    )
                        .add(() => { });
                }
            }
            this.moduleList.map((item, i) => {

                if (item.activites?.length > 0)
                    item.moduleCompleted = item.activites.every((activity) => activity.read)
                else item.moduleCompleted = false
            })
        }
    }

	viewImage(imageIndex, image) {
		if (!image.error) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: ResourceFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'viewImage'
						},
						{
							variableName: 'imageIndex',
							value: imageIndex
						},
						{
							variableName: 'resourceDetail',
							value: this.currentResourceDetail
						}
					]
				},
				disableClose: true,
				maxWidth: '950px',
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(async (result) => {

				if (result && typeof result === 'object') {
				}
			});
		}
	}

	isDocumentLoaded(event) {
		this.documentLoaded = true;
	}

	fullScreen(element) {
		if (navigator.onLine) {
			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.mozRequestFullScreen) {
				/* Firefox */
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				/* Chrome, Safari and Opera */
				element.webkitRequestFullscreen();
			} else if (element.msRequestFullscreen) {
				/* IE/Edge */
				element.msRequestFullscreen();
			}
		}
	}

	loadResource(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('../../resource/resource-detail/resource-detail.component'),
				componentData: [
					{
						variableName: 'actualResourceID',
						value: data.resourceID
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {

			if (result) {
			}
		});
	}

	startTest(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: TakeTestComponent,
				componentData: [
					{
						variableName: 'record',
						value: data
					},
					{
						variableName: 'action',
						value: 'testInprogress'
					},
					{
						variableName: 'testData',
						value: data
					},
					{
						variableName: 'courseID',
						value: this.resourceDetail.resourceID
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				if (navigator.onLine) {
					delete this.contentData.type;
					this.cdref.detectChanges();
					this.contentData.type = 'takeTest';
				}
				addEventListener('online', () => {
					delete this.contentData.type;
					this.cdref.detectChanges();
					this.contentData.type = 'takeTest';
				});
			}
		});

	}

	testDetail(data) {
		if (data.userTestStatus && data.userTestStatus.key && data.userTestStatus.key === 'completed') {
			for (const module of this.moduleList) {
				if (module.activites.length) {
					const testData = module.activites.find(items => items.type === 'AT' && items.id === data.testID);
					if (testData) {
						testData.read = true;
					}
				}
			}
			this.updatePercentage(true);
		}
	}

	collapsibleToggle(moudleRule, event, module) {
		if (moudleRule) {
			// module.opened = event ? false : true;
			if (navigator.onLine) {
				let title = this.locale.translate('course');
				let content = this.locale.translate('unlock_after_previous_content');
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					autoFocus: false,
					data: {
						action: 'alert',
						classes: 'warning',
						popup: true,
						icon: 'warning',
						title,
						content,
						buttons: [
									{
										type: 'main-action',
										caption: this.locale.translate('ok'),
										key: 'yes'
									},
								],
					},
					disableClose: true,
					maxWidth: '560px'
				});
				dialogRef.afterClosed().subscribe((resp) => {
					if (resp) {
						
					}
				});
			}
		}
		
	}

	ngOnDestroy() {
		if (this.timeLogInterval) {
			this.timeLogInterval.clearInterval();
			this.intervalCleared = true;
		}
	}

}
